import {Box, Link} from '@mui/material'

import {COLOR_CODE} from '@/utils/constants/colors'
import {FONT_SIZE, FONT_WEIGHT} from '@/utils/constants/globalStyle'
/**
 * LinkText component renders a styled link with customizable text, font size, font weight, and color.
 *
 * @param {Object} props - The properties object.
 * @param {string} props.id - The unique identifier for the link.
 * @param {string} props.text - The text to be displayed inside the link.
 * @param {('small'|'medium'|'large')} [props.fontSize=FONT_SIZE.SM] - The font size of the link text.
 * @param {string} [props.fontWeight=FONT_WEIGHT.NORMAL] - The font weight of the link text.
 * @param {string} [props.fontColor=COLOR.PRIMARY] - The color of the link text.
 * @param {function} props.handleClick - The function to handle click events on the link.
 * @param {string} [props.id=''] - Optional additional id to apply to the link text.
 * @param {string} [props.maxWidth] - Optional maximum width before text truncation with ellipsis. If not provided, width will be auto.
 * @param {boolean} [props.showTooltip=false] - Whether to show a tooltip with the full text on hover using the native title attribute.
 * @returns {JSX.Element} The rendered LinkText component.
 */
const LinkText = ({
  id,
  text,
  fontSize = FONT_SIZE.SM,
  fontWeight = FONT_WEIGHT.NORMAL,
  fontColor = COLOR_CODE._3387DF,
  handleClick,
  isPaddingHidden = false,
  maxWidth,
  showTooltip = false,
}) => {
  return (
    <Box>
      <Box
        className={` ${isPaddingHidden ? 'p-0' : 'px-2 py-1'}`}
        onClick={handleClick}
        title={showTooltip ? text : undefined}
      >
        <Link
          id={`link_text_${id}`}
          onClick={handleClick}
          component="button"
          underline="none"
          sx={{
            cursor: 'pointer',
            display: 'inline-block',
            color: fontColor,
            fontSize: fontSize,
            fontWeight: fontWeight,
            maxWidth: maxWidth || 'auto',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {text}
        </Link>
      </Box>
    </Box>
  )
}

export default LinkText
